export const getRandomNumber = (toNumber?: number) => Math.floor(Math.random() * (toNumber || 1e10));
